import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Stack } from '@mui/material';

export default function FieldClearButton({ disabled, onClear }) {
  return (
    <Stack
      p={1}
      zIndex={2}
      alignItems="center"
      justifyContent="center"
      sx={{ position: 'absolute', right: 0, top: 0, bottom: 0 }}
    >
      <IconButton
        color="error"
        disabled={disabled}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onClear();
        }}
        sx={{ width: 24, height: 24, fontSize: 16, bgcolor: 'error.lighter' }}
      >
        <CloseIcon fontSize="inherit" />
      </IconButton>
    </Stack>
  );
}
